export const youtubeData = {
  header: {
    badge: {
      text: "Video Gallery",
      icon: "PlayCircleOutlineIcon"
    },
    title: "Watch Our Inspections in Action",
    description: "See our professional home inspection process through these informative videos and learn what to expect during your property evaluation."
  },
  scrollHint: {
    text: "Swipe to watch more videos",
    icon: "SwipeIcon"
  },
  videos: [
    {
      id: 'qpeh2fbiS5w',
      title: 'Home Inspection Services | N S Mountains | SnagEasy | Inspection Tools',
      description: 'Learn about our comprehensive home inspection services and professional tools used for thorough property evaluation.',
      duration: '3:45',
      views: '2.5K views'
    },
    {
      id: 'b5c3nM-t23s',
      title: 'Home Inspection is Essential',
      description: 'Discover why home inspection is crucial before taking possession of your new property.',
      duration: '2:30',
      views: '1.8K views'
    },
    {
      id: 'TSoIW-ThrWQ',
      title: 'Home Inspection Before Possession',
      description: 'Complete guide to home inspection process and what to expect during the evaluation.',
      duration: '4:15',
      views: '3.2K views'
    },
    {
      id: '3Xmd_OH9eyA',
      title: 'होम इन्स्पेक्शन',
      description: 'होम इन्स्पेक्शन की आवश्यकता और प्रक्रिया के बारे में हिंदी में जानें।',
      duration: '3:20',
      views: '1.5K views'
    }
  ]
};
